export class PaymentMethod {
    public accountName: string;
    public accountNumber: string;
    public accountType: string;
    public accountVerification: string;
    public bankName: string;
    public companyKey: string;
    public isActive: boolean;
    public isDefault: boolean;
    public isVerified: boolean;
    public key: string;
    public routingNumber: string;
    public validationApiResponse: object;

    constructor(obj: {
        accountName: string;
        accountNumber: string;
        accountType: string;
        accountVerification?: string;
        bankName: string;
        companyKey: string;
        isActive: boolean;
        isDefault: boolean;
        isVerified: boolean;
        key: string;
        routingNumber: string;
        validationApiResponse?: object;
    }) {
        if (obj != null) {
            this.accountNumber =
                typeof obj.accountNumber === 'undefined' ? this.accountNumber : obj.accountNumber;

            this.accountName =
                typeof obj.accountName === 'undefined' ? this.accountName : obj.accountName;

            this.accountType =
                typeof obj.accountType === 'undefined' ? this.accountType : obj.accountType;

            this.accountVerification =
                typeof obj.accountVerification === 'undefined'
                    ? this.accountVerification
                    : obj.accountVerification;

            this.bankName = typeof obj.bankName === 'undefined' ? this.bankName : obj.bankName;

            this.companyKey =
                typeof obj.companyKey === 'undefined' ? this.companyKey : obj.companyKey;

            this.isActive = typeof obj.isActive === 'undefined' ? this.isActive : obj.isActive;
            this.isDefault = typeof obj.isDefault === 'undefined' ? this.isDefault : obj.isDefault;
            this.isVerified =
                typeof obj.isVerified === 'undefined' ? this.isVerified : obj.isVerified;

            this.key = typeof obj.key === 'undefined' ? this.key : obj.key;

            this.routingNumber =
                typeof obj.routingNumber === 'undefined' ? this.routingNumber : obj.routingNumber;

            this.validationApiResponse =
                typeof obj.validationApiResponse === 'undefined'
                    ? this.validationApiResponse
                    : obj.validationApiResponse;
        }
    }
}
